export default __webpack_public_path__ + "static/loading_product_icon_cos-14446beb771396ccca5449b2b89ae7d4.png";